<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
      :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
      :selection="{ mode: 'single' }"
      :show-borders='true'
      :style="{ height: localHeight, width: localWidth }"
      :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
      :summary="summary"
      :row-alternation-enabled="true"
      :allow-column-reordering="true"
      :allow-column-dragging="false"
      @content-ready="onContentReady")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'ControlWorkTime',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        caption: 'Объект слежения',
        alignment: 'center',
        columns: [{
          dataField: 'RowNum',
          caption: '№',
          fixed: true,
          width: 50,
        }, {
          dataField: 'Date',
          caption: 'Дата',
          customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
          alignment: 'center',
          width: 90,
        }, {
          dataField: 'Begin',
          caption: 'Начало',
          customizeText: params => new Date(params.value * 1000).toLocaleTimeString('ru', { timeZone: 'UTC' }),
          alignment: 'center',
          width: 90,
        }, {
          dataField: 'End',
          caption: 'Конец',
          customizeText: params => new Date(params.value * 1000).toLocaleTimeString('ru', { timeZone: 'UTC' }),
          alignment: 'center',
          width: 90,
        }],
      }, {
        dataField: 'WorkTime',
        caption: 'Время работы',
        alignment: 'center',
        width: 130,
      }, {
        dataField: 'RideTime',
        caption: 'Время в движении',
        alignment: 'center',
        width: 170,
      }, {
        caption: 'Пробег, км',
        alignment: 'center',
        columns: [{
          dataField: 'CityMileageKm',
          caption: 'Город',
          width: 80,
        }, {
          dataField: 'CountryMileageKm',
          caption: 'Загород',
          width: 85,
        }, {
          dataField: 'MileageKm',
          caption: 'Общий пробег',
          alignment: 'center',
          width: 115,
        }],
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'WorkTime',
        name: 'WorkTime',
        summaryType: 'custom',
        displayFormat: '{0}',
        showInGroupFooter: false,
        alignByColumn: true,
      }, {
        column: 'RideTime',
        name: 'RideTime',
        summaryType: 'custom',
        displayFormat: '{0}',
        showInGroupFooter: false,
        alignByColumn: true,
      }, {
        column: 'CityMileageKm',
        name: 'CityMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        showInGroupFooter: false,
        alignByColumn: true,
      }, {
        column: 'CountryMileageKm',
        name: 'CountryMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        showInGroupFooter: false,
        alignByColumn: true,
      }, {
        column: 'MileageKm',
        name: 'MileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        showInGroupFooter: false,
        alignByColumn: true,
      }],
      summary: null,
      reportSummary: [],
      index: 0,
    };
  },
  watch: {
    reportData (value) {
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
      this.getSummary();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getSummary();
  },
  methods: {
    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = rows;
    },

    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const totalValue = this.reportData.Data.Data[`Sum${options.name}`];
              if (totalValue !== undefined) {
                if (options.name === 'MileageKm' || options.name === 'CountryMileageKm' || options.name === 'CityMileageKm') {
                  value.totalValue = totalValue.toFixed(2);
                } else {
                  value.totalValue = totalValue;
                }
              }
            }
          },
          totalItems: this.summaryColoumn,
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;

              if (options.groupIndex === undefined) {
                const totalValue = this.reportData.Data[`Sum${options.name}`];
                if (totalValue !== undefined) {
                  if (options.name === 'MileageKm' || options.name === 'CountryMileageKm' || options.name === 'CityMileageKm') {
                    value.totalValue = totalValue.toFixed(2);
                  } else {
                    value.totalValue = totalValue;
                  }
                }
                this.index = 0;
              } else {
                value.totalValue = this.reportData.Data.Data[this.index] ? this.reportData.Data.Data[this.index][`Sum${options.name}`] : undefined;
                if (options.name === 'MileageKm') {
                  this.index += 1;
                }
              }
            }
          },
          totalItems: this.summaryColoumn,
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },
  },
};
</script>
